import React from "react";
import {Box} from "@mui/material";

const FormFieldLayout = ({children}) => {
    return <Box sx={{p: 1.5}}>
        {children}
    </Box>
}

export default FormFieldLayout